const CHAT_MESSAGE_LINK_REGEX = /((?:https?:\/\/|www\.)[^\s<>"']+)/gi
const TRAILING_LINK_PUNCTUATION_REGEX = /[.,!?;:)\]]+$/

type LinkifiedChatMessageSegment = {
  text: string
  url?: string
}

const normalizeChatLinkUrl = (url: string): string =>
  /^(?:https?:\/\/)/i.test(url) ? url : `https://${url}`

const isSafeHttpUrl = (url: string): boolean => {
  try {
    const normalizedUrl = new URL(url)
    return (
      (normalizedUrl.protocol === 'http:' ||
        normalizedUrl.protocol === 'https:') &&
      Boolean(normalizedUrl.hostname)
    )
  } catch {
    return false
  }
}

export const getLinkifiedChatMessageSegments = (
  message: string
): LinkifiedChatMessageSegment[] => {
  if (!message) return [{ text: '' }]

  const segments: LinkifiedChatMessageSegment[] = []
  let lastIndex = 0

  for (const match of message.matchAll(CHAT_MESSAGE_LINK_REGEX)) {
    if (match.index === undefined) continue

    const matchStartIndex = match.index
    const matchedText = match[0]

    if (matchStartIndex > lastIndex) {
      segments.push({ text: message.slice(lastIndex, matchStartIndex) })
    }

    const trailingPunctuationMatch = matchedText.match(
      TRAILING_LINK_PUNCTUATION_REGEX
    )
    const trailingPunctuation = trailingPunctuationMatch?.[0] ?? ''
    const linkText = trailingPunctuation
      ? matchedText.slice(0, -trailingPunctuation.length)
      : matchedText

    if (linkText) {
      const normalizedUrl = normalizeChatLinkUrl(linkText)
      segments.push({
        text: linkText,
        url: isSafeHttpUrl(normalizedUrl) ? normalizedUrl : undefined
      })
    }

    if (trailingPunctuation) {
      segments.push({ text: trailingPunctuation })
    }

    lastIndex = matchStartIndex + matchedText.length
  }

  if (lastIndex < message.length) {
    segments.push({ text: message.slice(lastIndex) })
  }

  return segments.length > 0 ? segments : [{ text: message }]
}
